import { render, staticRenderFns } from "./onlineProductShopee.vue?vue&type=template&id=462a4cad&scoped=true"
import script from "./onlineProductShopee.vue?vue&type=script&lang=js"
export * from "./onlineProductShopee.vue?vue&type=script&lang=js"
import style0 from "./onlineProductShopee.vue?vue&type=style&index=0&id=462a4cad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462a4cad",
  null
  
)

export default component.exports